"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupAcceptScreen = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./GroupAcceptScreen.css"));
var AcceptFlowContextProvider_1 = require("../AcceptFlowContextProvider");
var pages_common_1 = require("@qwilr/pages-common");
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
var SecuredByQwilr_2 = require("../Utils/SecuredByQwilr");
var Utils_1 = require("./Utils");
var inversify_react_1 = require("inversify-react");
var GetLetter_1 = require("../GroupAccept/GetLetter");
var classnames_1 = __importDefault(require("classnames"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DateStamp = function (_a) {
    var date = _a.date;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center" },
        react_1.default.createElement(kaleidoscope_1.Label, { className: styles.dateStamp, size: "s" }, new Date(date).toLocaleDateString(undefined, {
            day: "numeric",
            month: "short",
            year: "numeric",
        })),
        react_1.default.createElement(icons_1.Tick, { className: styles.tickIcon })));
};
var PaymentDetailsButton = function (_a) {
    var openPaymentDetailsScreen = _a.openPaymentDetailsScreen, disableButton = _a.disableButton, hasAnyoneAccepted = _a.hasAnyoneAccepted, payments = _a.payments;
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Please enter your details before making a payment", show: !hasAnyoneAccepted ? undefined : false, size: kaleidoscope_1.TooltipSize.Large, autoStack: false },
        react_1.default.createElement("div", null,
            react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: openPaymentDetailsScreen, disabled: disableButton, className: styles.payNowButton({ disabled: disableButton }) },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", padding: "m" },
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
                        react_1.default.createElement("div", { className: styles.subscriptionIcon },
                            react_1.default.createElement(icons_1.Subscription, null)),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                            "Enter payment details ",
                            !payments.paymentSettings.requireOnAccept ? "(optional)" : "")),
                    payments.paymentAddedAt ? (react_1.default.createElement(DateStamp, { date: payments.paymentAddedAt })) : (react_1.default.createElement(icons_1.ChevronRight, { className: styles.icon })))))));
};
var GroupAcceptScreen = function (_a) {
    var _b, _c, _d;
    var onAccepterClick = _a.onAccepterClick, openPaymentDetailsScreen = _a.openPaymentDetailsScreen, onClose = _a.onClose;
    var _e = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), settings = _e.settings, payments = _e.payments, isSimpleMode = _e.isSimpleMode, formHeaderHidden = _e.hideHeader, accepters = _e.accepters, isPreviewAccept = _e.isPreviewAccept, acceptersDataStore = _e.acceptersDataStore, accepterIndex = _e.accepterIndex;
    var hideHeader = formHeaderHidden || isSimpleMode;
    var projectCurrencies = (0, inversify_react_1.useInjection)("projectCurrencies");
    var projectTotal = (0, inversify_react_1.useInjection)("projectTotal");
    var _f = __read((0, pages_common_1.usePubSubEvent)("qwilr:quote-total-changed", {
        total: projectTotal.calculatePayTodaySingleCurrency(),
    }), 1), quoteTotal = _f[0].total;
    var quoteBlocksList = (0, inversify_react_1.useInjection)("quoteBlocksList");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var useNewAccepterSortingRules = usingFeature(FeatureFlag_1.default.SignatureInitialsWidgets);
    var paymentAmount = (0, Utils_1.getPaymentDetails)(payments === null || payments === void 0 ? void 0 : payments.paymentSettings, projectCurrencies, quoteTotal).paymentAmount;
    var paymentEnabled = Boolean(payments) && (paymentAmount > 0 || (isPreviewAccept && quoteBlocksList.get().length > 0));
    var finalisedAccepters = (_b = accepters === null || accepters === void 0 ? void 0 : accepters.finalisedAccepters) !== null && _b !== void 0 ? _b : [];
    var hasAnyoneAccepted = !!(accepters === null || accepters === void 0 ? void 0 : accepters.finalisedAccepters) && finalisedAccepters.length > 0;
    var disablePayNowButton = paymentEnabled && (!!(payments === null || payments === void 0 ? void 0 : payments.paymentAddedAt) || !hasAnyoneAccepted);
    var slots = [];
    if (useNewAccepterSortingRules) {
        slots = (0, Utils_1.makeAccepters)(settings.accepters.number, finalisedAccepters, {
            enabled: (_c = settings.accepters.enablePrefilledNames) !== null && _c !== void 0 ? _c : false,
            names: settings.accepters.prefilledNames,
        });
    }
    else {
        slots = finalisedAccepters.map(function (accepter) {
            return { name: accepter.name, acceptedAt: accepter.acceptedAt };
        });
        var finalisedAccepterNames_1 = slots.map(function (s) { return s.name; });
        var prefilledNames = (_d = settings.accepters.prefilledNames) !== null && _d !== void 0 ? _d : [];
        prefilledNames
            .filter(function (pa) { return !finalisedAccepterNames_1.includes(pa); })
            .forEach(function (n) { return slots.push({ name: n, acceptedAt: "" }); });
        var numberOfEmptySlots = settings.accepters.number - (slots === null || slots === void 0 ? void 0 : slots.length);
        for (var i = 0; i < numberOfEmptySlots; i++) {
            slots.push({ name: "", acceptedAt: "" });
        }
    }
    var handleAccepterClick = function (index, name) {
        acceptersDataStore === null || acceptersDataStore === void 0 ? void 0 : acceptersDataStore.setAccepterIndex(index);
        onAccepterClick(name);
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "l", relative: true },
        react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", direction: "horizontal", align: "center" },
            react_1.default.createElement("div", { className: styles.teamIcon },
                react_1.default.createElement(icons_1.Team, { size: icons_1.IconSize.Large, "aria-hidden": true })),
            !hideHeader && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), className: styles.closeButton, onClick: onClose, "aria-label": "Close" }))),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", align: "center" },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3" }, "Group Accept"),
            react_1.default.createElement(kaleidoscope_1.Text, { align: "center", size: "m" }, "To accept this document, please click on the available slot and enter your details.")),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", className: styles.slotsContainer },
            slots.map(function (slot, i) {
                var _a, _b, _c;
                var _d;
                var cardAccepted = !!slot.acceptedAt;
                var slotLocked = !cardAccepted && accepterIndex !== undefined && accepterIndex !== i;
                var cardDisabled = cardAccepted || slotLocked;
                return (react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: (0, classnames_1.default)((_a = {},
                        _a[Utils_1.acceptFormFocusableClassname] = !cardDisabled,
                        _a)), key: "".concat(slot.name, "-").concat(i), onClick: function () { return handleAccepterClick(i, slot.name); }, disabled: cardDisabled },
                    react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween", padding: "m" },
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
                            react_1.default.createElement("div", { className: (0, classnames_1.default)((_b = {},
                                    _b[styles.avatarLocked] = slotLocked,
                                    _b)) },
                                react_1.default.createElement(pages_common_1.UserAvatar, { name: (_d = slot.name) !== null && _d !== void 0 ? _d : "", url: "", size: "small" })),
                            react_1.default.createElement(kaleidoscope_1.Text, { className: (0, classnames_1.default)((_c = {
                                        "accepter-name": true
                                    },
                                    _c[styles.cardLocked] = slotLocked,
                                    _c)) }, slot.name ? slot.name : "Accepter ".concat((0, GetLetter_1.getLetter)(i)))),
                        !!slot.acceptedAt ? (react_1.default.createElement(DateStamp, { date: slot.acceptedAt })) : (react_1.default.createElement(icons_1.ChevronRight, { className: styles.icon, color: slotLocked ? "disabled" : "default" })))));
            }),
            paymentEnabled && payments && (react_1.default.createElement(PaymentDetailsButton, { openPaymentDetailsScreen: openPaymentDetailsScreen, disableButton: disablePayNowButton, hasAnyoneAccepted: hasAnyoneAccepted, payments: payments }))),
        react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { utmParams: SecuredByQwilr_2.acceptFlowMarketingParams })));
};
exports.GroupAcceptScreen = GroupAcceptScreen;
